<template>
  <v-container>
    <v-row>
      <!-- Columna para la medida -->
      <v-col cols="12" sm="12" md="4" lg="4" class="d-flex align-items-center">
        <p class="txtdata">
          {{ item.descripcion }}
        </p>
      </v-col>

      <!-- Columna para los botones y el campo de texto -->

      <v-col cols="4" sm="6" md="4" lg="4" class="d-flex align-items-center">
        <v-text-field
          label="Cantidad"
          v-model.number="item.cantidad"
          style="font-size: smaller"
          placeholder="cantidad"
          variant="solo"
          class="txtdata"
        ></v-text-field>
      </v-col>
      <v-col cols="4" sm="4" md="2" lg="2">
        <v-btn
          class="txtbutton txtdata"
          variant="flat"
          color="green-darken-3"
          @click="incrementarCantidad()"
          size="small"
          >+</v-btn
        >
        <v-spacer style="height: 5px"></v-spacer>
        <v-btn
          class="txtbutton txtdata"
          variant="flat"
          color="yellow-darken-3"
          @click="decrementarCantidad()"
          size="small"
          >-</v-btn
        >
        <v-spacer style="height: 5px"></v-spacer>
        <v-btn
          class="txtbutton"
          variant="flat"
          color="red-darken-3"
          @click="RemoveProductCard(item.codigo)"
          size="small"
          ><span class="mdi mdi-delete-forever"></span
        ></v-btn>
      </v-col>
      <v-col cols="4" sm="2" md="2" lg="2">
        <p class="txtdata">P.U.</p>
        <p class="txtdata" style="color: green">${{ item.precio2 }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: {
    item: {},
  },
  mounted() {

  },
  computed: {},
  methods: {
    ...mapActions('cartProduct', ['removeFromCartProduct']),

    RemoveProductCard(codigo) {
      this.removeFromCartProduct(codigo);
    },

    incrementarCantidad(index) {
      this.item.cantidad++;
    },
    decrementarCantidad(index) {
      if (this.item.cantidad > 0) {
        this.item.cantidad--;
      }
    },
  },
};
</script>

<style scoped>
.txtdata {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
}
</style>
